import React from "react";
import { connect } from "react-redux";
import history from "common/history";
import { Route, Switch, Redirect, Router } from "react-router-dom";
import Login from "./Login";
import Portal from "./Portal";

const Routes = ({ isAuthenticated }) => (
  <div>
    <Router history={history}>
      <Switch>
        <Route
          exact
          path="/login"
          render={(props) =>
            isAuthenticated ? (
              <Redirect to="/" {...props} />
            ) : (
              <Login {...props} />
            )
          }
        />
        <Route
          render={(props) =>
            isAuthenticated ? (
              <Portal {...props} />
            ) : (
              <Redirect to={`/login?redirect=${props.location.pathname}`} />
            )
          }
        />
      </Switch>
    </Router>
  </div>
);

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Routes);
